import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-session-expired-dialog',
  templateUrl: './session-expired-dialog.component.html'
})
export class SessionExpiredDialogComponent {

  constructor(private dialogRef: MatDialogRef<SessionExpiredDialogComponent>) {}

  close() {
    this.dialogRef.close();
  }
}
